import { toFormData } from "@king-ict/eupisi-ui/utils";
import { useSelector } from "react-redux";

import {
  createCriterionDocument,
  createFromExistingCriterionDocument,
  deleteCriterionDocument,
  getCriterionDocument,
} from "../../../api/kindergartenApi";
import CriterionDocumentMethodsReturnType from "../../../models/Criterion/CriterionDocumentMethodsReturnType";
import CriterionUploadDocument from "../../../models/Criterion/CriterionUploadDocument";
import { DocumentDownloadRemoveMethodReturnType } from "../../../models/Request/DocumentMethodsReturnType";
import RequestCriterion from "../../../models/Request/RequestCriterion";
import { RequestDocumentData } from "../../../models/Request/RequestDocumentData";
import { selectMainInfo } from "../../../slices/requestSlice";

interface Props {
  criterion: RequestCriterion;
  onDocumentsChange: (
    criterion: RequestCriterion,
    documents: RequestDocumentData[]
  ) => void;
  onRemoveDocumentFromList: (
    criterion: RequestCriterion,
    document: RequestDocumentData
  ) => void;
  setDocumentsModalOpenId: Function;
  onCloseDocumentModal: Function;
}

export function useCriterionDocuments(): DocumentDownloadRemoveMethodReturnType;
export function useCriterionDocuments(
  props: Props
): CriterionDocumentMethodsReturnType;
export function useCriterionDocuments(props?: Props) {
  const requestMainInfoState = useSelector(selectMainInfo);

  const handleDownloadDocument = (document: RequestDocumentData) => {
    if (document.fileID) {
      getCriterionDocument(document.fileID);
    }
  };

  const handleRemoveDocuments = (documents: RequestDocumentData[]) => {
    let ids = new Array<number>();
    documents.forEach((document) => {
      if (document.id) {
        ids.push(document.id);
      }
    });

    if (ids.length > 0) {
      deleteCriterionDocument(ids);
    }
  };

  if (props) {
    const {
      criterion,
      onDocumentsChange,
      onRemoveDocumentFromList,
      setDocumentsModalOpenId,
      onCloseDocumentModal,
    } = props;

    const handleCloseDocumentsModal = (documents: RequestDocumentData[]) => {
      handleRemoveDocuments(documents);

      onCloseDocumentModal();
    };

    const handleConfirmDocumentsModal = (documents: RequestDocumentData[]) => {
      onDocumentsChange(criterion, documents);

      setDocumentsModalOpenId(undefined);
    };

    const handleUploadDocuments = async (files: File[]) => {
      var documents = await createCriterionDocument(
        toFormData<CriterionUploadDocument>({
          requestUID: requestMainInfoState.uId,
          applicantParentOib: requestMainInfoState.applicantParentOib,
          childOib: requestMainInfoState.childOib,
          files: files,
          institutionCriterionId: criterion.institutionCriterionId,
        })
      );
      return documents;
    };

    const handleUploadExistingDocument = async (
      document: RequestDocumentData
    ) => {
      var docResult = await createFromExistingCriterionDocument(
        document.fileID!,
        document.origin,
        criterion.institutionCriterionId
      );
      return docResult;
    };

    const handleRemoveDocument = (document: RequestDocumentData) => {
      if (document.id) {
        const ids = [document.id];
        deleteCriterionDocument(ids);
      }
    };

    const handleRemoveDocumentFromList = (document: RequestDocumentData) => {
      onRemoveDocumentFromList(criterion, document);
      handleRemoveDocument(document);
    };

    const handleOpenDocumentsModal = () => {
      setDocumentsModalOpenId(criterion.institutionCriterionId);
    };

    return {
      handleUploadDocuments,
      handleUploadExistingDocument,
      handleConfirmDocumentsModal,
      handleCloseDocumentsModal,
      handleOpenDocumentsModal,
      handleDownloadDocument,
      handleRemoveDocumentFromList,
      handleRemoveDocument,
      handleRemoveDocuments,
    };
  } else {
    return {
      handleDownloadDocument,
      handleRemoveDocuments,
    };
  }
}
